import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Box } from '@mui/material';

const CustomList = ({ anchor, toggleDrawer, setView, view, surveyToolsAllowed }) => (
  <Box
    sx={{
      width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250,
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    role="presentation"
    onClick={toggleDrawer(false)}
    onKeyDown={toggleDrawer(false)}
  >
    <List>
      <ListItem key={'Chat'} disablePadding>
        <ListItemButton
          style={{
            height: '56px',
            backgroundColor: view === 'chat' ? '#D2E5F5' : 'transparent',
            borderRadius: 100,
          }}
          onClick={() => {
            setView('chat');
            toggleDrawer(false);
          }}
        >
          <ListItemIcon>
            <QuestionAnswerIcon style={{ fontSize: 27, color: '#41484D' }} />
          </ListItemIcon>
          <ListItemText primary={'Chat'} />
        </ListItemButton>
      </ListItem>
      {surveyToolsAllowed ? (
        <ListItem key={'Survey'} disablePadding>
          <ListItemButton
            style={{
              height: '56px',
              backgroundColor: view === 'survey' ? '#D2E5F5' : 'transparent',
              borderRadius: 100,
            }}
            onClick={() => {
              setView('survey');
              toggleDrawer(false);
            }}
          >
            <ListItemIcon>
              <ListAltIcon style={{ fontSize: 27, color: '#41484D' }} />
            </ListItemIcon>
            <ListItemText primary={'Survey'} />
          </ListItemButton>
        </ListItem>
      ) : null}
      <ListItem key={'Settings'} disablePadding>
        <ListItemButton
          style={{
            height: '56px',
            backgroundColor: view === 'settings' ? '#D2E5F5' : 'transparent',
            borderRadius: 100,
          }}
          onClick={() => {
            setView('settings');
            toggleDrawer(false);
          }}
        >
          <ListItemIcon>
            <SettingsIcon style={{ fontSize: 27, color: '#41484D' }} />
          </ListItemIcon>
          <ListItemText primary={'Settings'} />
        </ListItemButton>
      </ListItem>
    </List>
  </Box>
);

export default CustomList;
